import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Link, useLocation, Outlet } from "react-router-dom";
import { Colors } from "../../../../theme";
import { useTranslation } from "react-i18next";

const Everyone = () => {
  const location = useLocation();
  const {t} = useTranslation() as any
  
  const [selectedIndex, setSelectedIndex] = useState<number>(() => {
    const currentPath = location.pathname;
    if (currentPath.includes("/checklist/everyone/all-tasks")) return 0;
    if (currentPath.includes("/checklist/everyone/employees")) return 1;
    if (currentPath.includes("/checklist/everyone/checklists")) return 2;
    return -1;
  });

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath.includes("/checklist/everyone/all-tasks")) setSelectedIndex(0);
    if (currentPath.includes("/checklist/everyone/employees")) setSelectedIndex(1);
    if (currentPath.includes("/checklist/everyone/checklists")) setSelectedIndex(2);
  }, [location]);

  return (
    <Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box style={{ display: "flex", justifyContent: "flex-start" }}>
          <Typography color={Colors.black} variant="h6">
            {t("00_06_everyone").toUpperCase()}
          </Typography>
        </Box>

        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "center",
            gap: "40px",
            flex: 1,
          }}
        >
          <Link
            to="/checklist/everyone/all-tasks"
            style={{
              fontWeight: "400",
              fontSize: "13px",
              cursor: "pointer",
              textDecoration: "none",
              color: selectedIndex === 0 ? Colors.primary : Colors.black,
              whiteSpace: "nowrap",
            }}
            onClick={() => setSelectedIndex(0)}
          >
            {t("26_00_all")}
          </Link>

          <Link
            to="/checklist/everyone/employees"
            style={{
              fontWeight: "400",
              fontSize: "13px",
              cursor: "pointer",
              textDecoration: "none",
              color: selectedIndex === 1 ? Colors.primary : Colors.black,
              whiteSpace: "nowrap",
            }}
            onClick={() => setSelectedIndex(1)}
          >
            {t("09_01_employees")}
          </Link>

          <Link
            to="/checklist/everyone/checklists"
            style={{
              fontWeight: "400",
              fontSize: "13px",
              cursor: "pointer",
              textDecoration: "none",
              color: selectedIndex === 2 ? Colors.primary : Colors.black,
              whiteSpace: "nowrap",
            }}
            onClick={() => setSelectedIndex(2)}
          >
            {t("26_00_checklists")}
          </Link>
        </Box>
      </Box>
      <Box
        style={{
          width: "100%",
          borderBottom: "2px solid #E0E0E0",
          marginTop: "24px",
          marginBottom: "10px",
        }}
      />
      <Outlet />
    </Box>
  );
};

export default Everyone;
